import React, { useEffect, useState } from "react";
import PortfolioItem from "./PortfolioItem";


const Portfolio = () => {
  const [portfolioData, setPortfolioData] = useState([])
  useEffect(()=>{
    fetch('/projectdata.json')
    .then(res => res.json())
    .then(data => setPortfolioData(data))
  },[])
  return (
    <section className="pb-10">
    <h3 style={{textAlign:'center', marginTop:'60px', marginBottom:'40px', fontWeight:'bold', fontSize:'26px'}}>Personal Projects</h3>
    <div style={{height:'5px', width:'50px', background:'#E54042', margin:'0 auto', marginTop:'-30px', marginBottom:'30px'}}></div>
      <div className="flex flex-wrap md:px-4">
        {portfolioData.map((portfolio, id) => (
          <PortfolioItem portfolio={portfolio} key={id} />
        ))}
      </div>
    </section>
  );
};

export default Portfolio;
